// src/socket/config.js
import { io } from 'socket.io-client';

const getAuthToken = () => localStorage.getItem('accessToken');

const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_URL || 'wss://api.cliclaim.com';

export const socket = io(`${SOCKET_BASE_URL}/claim`, {
  autoConnect: false, // ✅ Don't auto-connect
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  auth: (cb) => {
    cb({ token: getAuthToken() }); // ✅ Dynamic token
  }
});

// Connect manually after login
export const connectSocket = () => {
  if (!socket.connected) {
    socket.connect();
  }
};

export const updateSocketAuth = (newToken) => {
  socket.auth = { token: newToken };
  socket.disconnect().connect();
};
